export default {
  namespaced: true, //使用命名空间，这样只在局部使用
  state: {
    listHeaderParams: {
      titles: ['民生直通车', '小强热线', '天天315', '梁心帮办'],
      helpCids: [383, 384, 385, 382],
      communityCids: [383, 384, 385, 382]
    },
    helpCid: 2, // 帮办cid
    communityCid: 386, // 社区cid 363测试 386正式
    newsIds: [870, 871, 872, 489] // 新闻id
  },
  mutations: {},
  getters: {}
}
